import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {SecurityAutocompleteModule} from '../security-autocomplete';
import {SecurityInputComponent} from './security-input.component';

@NgModule({
    imports: [
        CommonModule,
        SecurityAutocompleteModule
    ],
    declarations: [
        SecurityInputComponent
    ],
    exports: [
        SecurityInputComponent
    ]
})
export class SecurityInputModule {}
